import { clsx } from "clsx";
import { readableColor, shade, tint } from "polished";
import { type FC, useRef } from "react";

import { useTooltip } from "../../hooks/useTooltip.ts";
import { getCssColor } from "../../utils/color/getCssColor.ts";
import { AnimatedTooltip } from "../Tooltip/AnimatedTooltip.tsx";
import type { Project } from "./project.d.ts";
import style from "./ProjectBadge.module.css";

export interface ProjectColoredBadgeProps {
  project?: Project;
  size?: "normal" | "small" | "menu"; // TODO Add tiny to replace ProjectColoredLink
}

export const ProjectBadge: FC<ProjectColoredBadgeProps> = (props) => {
  const triggerRef = useRef<HTMLDivElement>(null);
  const tooltipRef = useRef<HTMLDivElement>(null);
  const { triggerProps, tooltipProps, state } = useTooltip(triggerRef, { closeDelay: 0 });

  const bgColor = getCssColor(props.project?.color || "#e1e1e5");
  const txtColor = readableColor(bgColor, shade(0.6, bgColor), tint(0.6, bgColor), false);

  if (!props.project) return null;

  return (
    <>
      <div
        className={clsx(style.badge, {
          [style.size_normal]: props.size == null || props.size === "normal",
          [style.size_small]: props.size === "small",
          [style.size_menu]: props.size === "menu",
        })}
        style={{ backgroundColor: bgColor, color: txtColor }}
        {...triggerProps}
        ref={triggerRef}
      >
        <span className={style.badge_text}>{props.project.name?.slice(0, 2).toUpperCase()}</span>
      </div>
      <AnimatedTooltip
        title={props.project.name}
        domProps={tooltipProps}
        ref={tooltipRef}
        targetRef={triggerRef}
        state={state}
        offset={4}
        nonInteractive
      >
        {props.project?.description}
      </AnimatedTooltip>
    </>
  );
};
